import { invoker } from 'ramda';

export const stopPropagation = invoker(0, 'stopPropagation');

export default {
  stopPropagation,
};
